import {
  IncidentMessage,
  IncidentMessageType,
  lightTheme,
  vDriveDeliveryStatus,
} from '@vgrubs/components';

// Barrel values (enums, the theme) are only read inside these functions: this page is imported
// eagerly by the route table, and a top-level read can run before the barrel has initialised.

/** The statuses the backend accepts a message for, in the order a delivery reaches them. */
export function messageStatuses() {
  return [
    vDriveDeliveryStatus.pending_assign,
    vDriveDeliveryStatus.runner_assigned,
    vDriveDeliveryStatus.arrived_pickup,
    vDriveDeliveryStatus.en_route_dropoff,
    vDriveDeliveryStatus.completed,
    vDriveDeliveryStatus.cancelled,
  ];
}

/** Each status takes one message. `keep` stays available: it is the one being edited. */
export function freeStatuses(
  messages: IncidentMessage[],
  keep?: vDriveDeliveryStatus | null
) {
  return messageStatuses().filter(
    (status) => status === keep || !messages.some((m) => m.status === status)
  );
}

export function isEtaMessage(message: IncidentMessage) {
  return message.type === IncidentMessageType.etaIncreased;
}

/** Status messages in delivery order, then the running-late one. */
export function sortMessages(messages: IncidentMessage[]) {
  // The enum is declared in delivery order.
  const order = Object.values(vDriveDeliveryStatus);
  const rank = (m: IncidentMessage) =>
    m.status ? order.indexOf(m.status) : order.length;
  return [...messages].sort((a, b) => rank(a) - rank(b));
}

export const ETA_TAG = '#eta';

/** `#eta` is rejected by the backend anywhere but the running-late message. */
export function tagsFor(type: IncidentMessageType) {
  const tags = ['#customer-name', '#store-name', '#tracking-link'];
  return type === IncidentMessageType.etaIncreased ? [...tags, ETA_TAG] : tags;
}

export function typeOptions() {
  return [
    {
      type: IncidentMessageType.status,
      label: 'Status change',
      description:
        'Sent to the customer when the delivery reaches the selected status.',
    },
    {
      type: IncidentMessageType.etaIncreased,
      label: 'Delivery running late',
      description:
        'Sent to the customer when their estimated arrival time moves later, at most once every 10 minutes.',
    },
  ];
}

export function runningLatePill() {
  // Blue: no status pill uses it, and orange sat too close to Pending Assign's yellow.
  return { name: 'Running Late', color: lightTheme.blue };
}
